import React, { forwardRef } from "react";
import Title from "../Title";
import styles from "./index.module.scss";

const Exclusion = forwardRef((props, ref) => {
  return (
    <div ref={ref} className={styles.exclusion}>
      <Title title={props.title} />
      <div className={styles.exclusion__content} dangerouslySetInnerHTML={{ __html: props.exclusion }}></div>
    </div>
  );
});

export default Exclusion;
